import React, { useState } from 'react';
import { truncatePhone, truncateEmail } from '../utils/helpers';

const ContactField = ({ label, value, type, clinicId }) => {
  const [showFull, setShowFull] = useState(false);
  const [fullData, setFullData] = useState(null);
  const [loading, setLoading] = useState(false);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  const fetchFullData = async () => {
    if (fullData) {
      setShowFull(true);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${backendUrl}/api/clinics/${clinicId}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();
        setFullData(data);
        setShowFull(true);
      } else if (response.status === 429) {
        alert('Kérjük várjon egy kicsit a további kérések előtt.');
      } else if (response.status === 403) {
        alert('Hozzáférés megtagadva.');
      } else {
        alert('Hiba történt az adatok betöltése során.');
      }
    } catch (error) {
      console.error('Error fetching contact data:', error);
      alert('Hiba történt az adatok betöltése során.');
    }
    setLoading(false);
  };

  const displayValue = () => {
    if (showFull && fullData) {
      return type === 'phone' ? fullData.phone : fullData.email;
    }
    return type === 'phone' ? truncatePhone(value) : truncateEmail(value);
  };

  const shouldShow = value && value.trim() !== '';

  if (!shouldShow) return null;

  return (
    <div>
      <h4 className="font-semibold text-gray-800">{label}:</h4>
      <div className="flex items-center gap-3">
        <p className="text-gray-600">{displayValue()}</p>
        {!showFull && (
          <button
            onClick={fetchFullData}
            disabled={loading}
            className="bg-white text-black px-3 py-1 rounded-xl shadow-md hover:shadow-lg transition-all text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed border border-gray-200"
          >
            {loading ? 'Betöltés...' : 'Mutat'}
          </button>
        )}
      </div>
    </div>
  );
};

// CityAutocomplete Component for Admin Forms

export default ContactField;
